/**
 * Identidade do pacote — GERADO por `scripts/generate-version.ts`.
 *
 * NÃO editar à mão, e NÃO fixar literal em outro lugar: até 2026-09-02 havia três
 * versões diferentes no repositório e o User-Agent reportava uma quarta, inexistente.
 * `tests/unit/version.test.ts` compara estas constantes com o `package.json` e
 * falha na divergência.
 */

/** Nome do pacote como publicado no npm. */
export const PACKAGE_NAME = 'nfe-io';

/** Versão desta build, vinda do `package.json`. */
export const VERSION = '6.0.0';
